import { ItemQuestionario } from "src/app/questionario/questao/item-questionario-base";
import { TipoItemQuestionario } from "src/app/questionario/questao/model/tipo-item-questionario.enum";

export class QuestaoDropdown extends ItemQuestionario<TipoItemQuestionario> {

  constructor(options: {} = {}) {
    super(options);
    this.questao.tipo = TipoItemQuestionario.DROPDOWN;
  }

  getLabel(): string {
    return 'Dropdown';
  }

  getMaterialIcon(): string {
    return 'arrow_drop_down_circle';
  }

  isQuestaoEstruturada(): boolean {
    return true;
  }
}
